import { FC } from 'react';
import { cn } from '@/shared/lib';
import { PATH } from '@/app/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { setCatalogActiveCategoryId, setCatalogScrollToCategoryId, useAppDispatch, useAppSelector } from '@/app/store';
import { ClientMenuCategoryDto } from '@/app/store/api/restApi';

interface CatalogMenuCategoriesProps {
  categories: ClientMenuCategoryDto[];
  onNavigate: VoidFunction;
}

export const CatalogMenuCategories: FC<CatalogMenuCategoriesProps> = ({ categories, onNavigate }) => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const activeCategoryId = useAppSelector((state) => state.application.catalogActiveCategoryId);
  const selectedId = activeCategoryId ?? categories[0]?.id;

  const handleClick = (id: string) => {
    dispatch(setCatalogActiveCategoryId(id));
    onNavigate();

    if (pathname === PATH.catalog) {
      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'auto', block: 'start' });
      });
    } else {
      dispatch(setCatalogScrollToCategoryId(id));
      nav(PATH.catalog);
    }
  };

  return (
    <div className='flex flex-col overflow-y-auto show-scrollbar'>
      {categories.map((category) => (
        <button
          key={category.id}
          type='button'
          onClick={() => handleClick(category.id)}
          className={cn(
            'py-2 text-start text-sm leading-5 cursor-pointer',
            selectedId === category.id ? 'font-medium text-primary' : 'text-muted-foreground',
          )}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
};
